var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 34,
    viewBox: "0 0 21 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4969 0L10.2676 0.774754V23.2563L10.4969 23.4839L20.9938 17.3154L10.4969 0Z",
    fill: "#A8D05D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4969 0L0 17.3154L10.4969 23.4839V12.5721V0Z",
    fill: "#BFE678"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4964 25.4598L10.3672 25.6164V33.6249L10.4964 34.0001L20.9996 19.2944L10.4964 25.4598Z",
    fill: "#A8D05D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4969 34.0001V25.4598L0 19.2944L10.4969 34.0001Z",
    fill: "#BFE578"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4961 23.484L20.9929 17.3156L10.4961 12.5723V23.484Z",
    fill: "#85A747"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.3156L10.4968 23.484V12.5723L0 17.3156Z",
    fill: "#9ABE57"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthSelected);
export default __webpack_public_path__ + "static/media/ethSelected.78eeebbd8eb3dfde290f601e09f6d0b4.svg";
export { ForwardRef as ReactComponent };